(function () {
  const FLOOR_WITH_LIFT_ID = 63370529571165;
  const FLOOR_NO_LIFT_ID = 63370527932765;

  function getElements() {
    return {
      floorCheckbox: document.getElementById('floorDeliveryCheckbox'),
      liftCheckbox: document.getElementById('liftCheckbox'),
      liftWrapper: document.getElementById('liftOptionWrapper')
    };
  }

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function updateCart(url, body) {
    const section = document.querySelector("[data-cart-wrapper]");
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...body,
        sections: [section.dataset.section]
      })
    });

    const cart = await response.json();

    if (typeof cartContentUpdate === 'function') {
      cartContentUpdate(cart, section.dataset.section);
    }

    return cart;
  }

  async function addItem(variantId) {
    return updateCart('/cart/add.js', {
      id: variantId,
      quantity: 1
    });
  }

  async function removeItem(variantId) {
    return updateCart('/cart/update.js', {
      updates: {
        [variantId]: 0
      }
    });
  }


  function cartHas(cart, variantId) {
    return cart.items.some(item => item.variant_id === variantId);
  }

  async function syncUI() {
    const cart = await getCart();
    const { floorCheckbox, liftCheckbox, liftWrapper } = getElements();
    
    if (!floorCheckbox || !liftCheckbox || !liftWrapper) return;

    const hasLift = cartHas(cart, FLOOR_WITH_LIFT_ID);
    const hasNoLift = cartHas(cart, FLOOR_NO_LIFT_ID);

    if (hasLift || hasNoLift) {
      floorCheckbox.checked = true;
      liftWrapper.style.display = 'block';
      liftCheckbox.checked = hasLift;
    } else {
      floorCheckbox.checked = false;
      liftCheckbox.checked = false;
      liftWrapper.style.display = 'none';
    }
  }

  // Event delegation - az event listener a document-re kerül, így megmarad újrarenderelés után is
  document.addEventListener('change', async function (e) {
    const target = e.target;

    // Floor delivery checkbox
    if (target.id === 'floorDeliveryCheckbox') {
      const cart = await getCart();
      const { liftCheckbox, liftWrapper } = getElements();
      
      if (!liftCheckbox || !liftWrapper) return;

      if (target.checked) {
        if (!cartHas(cart, FLOOR_NO_LIFT_ID) && !cartHas(cart, FLOOR_WITH_LIFT_ID)) {
          await addItem(FLOOR_NO_LIFT_ID);
        }
        liftWrapper.style.display = 'block';
      } else {
        await removeItem(FLOOR_WITH_LIFT_ID);
        await removeItem(FLOOR_NO_LIFT_ID);
        liftCheckbox.checked = false;
        liftWrapper.style.display = 'none';
      }

      syncUI();
      document.dispatchEvent(new Event('cart:updated'));
    }

    // Lift checkbox
    if (target.id === 'liftCheckbox') {
      const cart = await getCart();

      if (target.checked) {
        if (cartHas(cart, FLOOR_NO_LIFT_ID)) {
          await removeItem(FLOOR_NO_LIFT_ID);
        }
        if (!cartHas(cart, FLOOR_WITH_LIFT_ID)) {
          await addItem(FLOOR_WITH_LIFT_ID);
        }
      } else {
        if (cartHas(cart, FLOOR_WITH_LIFT_ID)) {
          await removeItem(FLOOR_WITH_LIFT_ID);
        }
        if (!cartHas(cart, FLOOR_NO_LIFT_ID)) {
          await addItem(FLOOR_NO_LIFT_ID);
        }
      }

      syncUI();
      document.dispatchEvent(new Event('cart:updated'));
    }
  });

  // 🔁 Ha a kosár máshol változik (qty + / −, drawer)
  document.addEventListener('cart:updated', syncUI);

  // első betöltés
  syncUI();
})();